import { MediaTile, Span } from "@icg360/design-system";

import type { KeystoneInspectionAsset } from "data/keystone-api-mapping";

import styles from "./inspection-thumbnail-strip.module.scss";
import { writeOutThumbnailMediaTileProps } from "./inspections-helpers";

export type InspectionThumbnailStripItem = {
  id: string;
  asset?: KeystoneInspectionAsset;
};

export const InspectionThumbnailStrip = ({
  heading,
  maxPhotosInRow,
  onPreviewClick,
  orderedItems,
}: {
  heading: string;
  maxPhotosInRow: number;
  onPreviewClick: (activeAssetId?: string) => void;
  orderedItems: InspectionThumbnailStripItem[];
}) => {
  if (!orderedItems.length) {
    return null;
  }

  const visibleItems =
    orderedItems.length > maxPhotosInRow
      ? orderedItems.slice(0, maxPhotosInRow - 1)
      : orderedItems;

  return (
    <div className={styles.fileListContainer}>
      <Span bold>{heading}</Span>
      <ul className={styles.fileList}>
        {visibleItems.map(({ id, asset }) => {
          const imageUrl = `/api/inspection/image/${id}`;
          return (
            <li className={styles.fileListItem} key={id}>
              <MediaTile
                {...writeOutThumbnailMediaTileProps(asset, imageUrl)}
                orientation="landscape"
                imageFit="cover"
                description={asset?.assetFileName ?? `Inspection asset: ${id}`}
                onPreviewClick={() => onPreviewClick(id)}
                className={styles.fileTile}
              />
            </li>
          );
        })}
        {orderedItems.length > maxPhotosInRow ? (
          <li className={styles.fileTileOverflow}>
            <MediaTile.Overflow
              onClick={() => onPreviewClick()}
              text={`+${orderedItems.length - (maxPhotosInRow - 1)} more`}
            />
          </li>
        ) : null}
      </ul>
    </div>
  );
};
